import { createSelector } from 'reselect';
import EmbeddingType from '../../utils/embeddingType';
/* eslint-disable import/prefer-default-export -- should not export default in selectors */

export const selectOperationsMenu = (state) => state.OperationsMenu;
export const selectEmbeddingMainType = createSelector(selectOperationsMenu, (OperationsMenu) =>
  EmbeddingType.getFilterTapType(OperationsMenu.embeddingType),
);
export const selectEmbeddingFullType = createSelector(
  selectOperationsMenu,
  (OperationsMenu) => OperationsMenu.embeddingType,
);
